<script>
  import api from "../services/api.js";

  export let compact = false;

  let name = "";
  let email = "";
  let phoneNumber = "";
  let loading = false;
  let message = "";
  let messageType = "";

  async function handleSubmit() {
    loading = true;
    message = "";

    try {
      const data = {
        name: name.trim(),
        email: email.trim(),
        phone_number: phoneNumber.trim() || null
      };

      const response = await api.joinWaitlist(data);
      message = response.message || "You've been added to the waitlist! Check your email for confirmation.";
      messageType = "success";

      // Clear form on success
      name = "";
      email = "";
      phoneNumber = "";
    } catch (error) {
      console.error("Waitlist signup error:", error);
      if (error.response && error.response.data && error.response.data.detail) {
        message = error.response.data.detail;
      } else {
        message = "Something went wrong. Please try again later.";
      }
      messageType = "error";
    } finally {
      loading = false;
    }
  }
</script>

<div class="w-full {compact ? 'max-w-md mx-auto' : 'max-w-md'}">
  {#if !compact}
    <h2 class="text-xl font-semibold text-ink">Join the waitlist</h2>
    <p class="text-sm text-ink-secondary mt-1 mb-6">
      We're currently awaiting approval from Alpaca Markets to enable account
      creation. Leave your details and we'll let you know the moment signups open.
    </p>
  {/if}

  {#if message}
    <div class="banner {messageType === 'success' ? 'banner-success' : 'banner-danger'} mb-4">
      {message}
    </div>
  {/if}

  <form on:submit|preventDefault={handleSubmit} class="space-y-4">
    <div>
      <label class="label" for="waitlist-name">Name</label>
      <input
        id="waitlist-name"
        type="text"
        bind:value={name}
        placeholder="Your full name"
        required
        class="input"
      />
    </div>

    <div>
      <label class="label" for="waitlist-email">Email</label>
      <input
        id="waitlist-email"
        type="email"
        bind:value={email}
        placeholder="you@example.com"
        required
        class="input"
      />
    </div>

    <div>
      <label class="label" for="waitlist-phone">
        Phone <span class="font-normal text-ink-tertiary">(optional, US only)</span>
      </label>
      <input
        id="waitlist-phone"
        type="tel"
        bind:value={phoneNumber}
        placeholder="(555) 123-4567"
        class="input"
      />
    </div>

    <button type="submit" disabled={loading} class="btn btn-primary w-full">
      {#if loading}
        <i class="fas fa-spinner fa-spin"></i> Joining…
      {:else}
        Join the waitlist
      {/if}
    </button>

    <p class="text-xs text-ink-tertiary text-center">
      No spam — one email when we launch.
    </p>
  </form>
</div>
